import { render, staticRenderFns } from "./AboutHistoryPage.vue?vue&type=template&id=9c734898&scoped=true"
import script from "./AboutHistoryPage.vue?vue&type=script&lang=js"
export * from "./AboutHistoryPage.vue?vue&type=script&lang=js"
import style0 from "./AboutHistoryPage.vue?vue&type=style&index=0&id=9c734898&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c734898",
  null
  
)

export default component.exports